import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/exp-components';
import {scrollToSectionTop} from '@learningblocks/protocol-constants/lib/Utilities';
import './style.scss';

//import { PDFDownloadLink } from "@react-pdf/renderer";
//import { PdfDocument } from "./Report/Report";

const CONTENT_SECTION_SELECTOR = 'div.notebook-content__body';
const USE_REPORT_READOUT = true;

export class ContentFooter extends React.Component {
  goToNextSection = () => {
    scrollToSectionTop(CONTENT_SECTION_SELECTOR);
    this.props.toNextSection(this.props.nextSection.value);
  };

  endSimulation = () => {
    this.props.setModal({
      display: false,
      type: "END_SIMULATION",
      size: 'md',
      connect: -1
    })
    this.props.showModal({
      display: true
    })
  };

  nextSectionButton() {
    return (
      <Button className='nextSection' onClick={this.goToNextSection}>
        Next section
      </Button>
    );
  }
  endSimulationButton(){
    return (
      <Button className='endSimulation' onClick={this.endSimulation}>
        End simulation
      </Button>
    );
  };
  simulationReportOut(){
    return (
      <div className="report-footer">
        <p>You have completed this simulation.</p>
        <Button className='endSimulation' onClick={this.endSimulation}>
          End simulation
        </Button>
        {/*<Button className='downloadReport'>
          <PDFDownloadLink
            style={{textDecoration: "none", color: "#333333"}}
            document={<PdfDocument />}
            fileName="PCR_Protocol_Sim_Report.pdf"
          >
            {({ blob, url, loading, error }) =>
              loading ? "Loading document..." : "Download report"
            }
          </PDFDownloadLink>
        </Button>*/}
      </div>
    )
  };

  render() {
    return (
      <div className='notebook-content__footer'>
      {
        (this.props.nextSection)?
          this.nextSectionButton():
          (!USE_REPORT_READOUT)?
            this.endSimulationButton():
            this.simulationReportOut()
      }
      </div>
    );
  }
}

ContentFooter.propTypes = {
  nextSection: PropTypes.object,
  toNextSection: PropTypes.func,
};
